// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'folder-solid';

export const Component = () => (
  <path d='M24.521 5.927v16.715c0 .24-.096.48-.287.67a.946.946 0 0 1-.67.288H.957a.946.946 0 0 1-.67-.288.946.946 0 0 1-.288-.67V3.006c0-.239.096-.479.287-.718A.946.946 0 0 1 .958 2H9.1c.527 0 .814.24.91.67l.767 2.3h12.787c.24 0 .48.096.67.287a.946.946 0 0 1 .288.67Z' />
);

export const viewBox = '0 0 25 25';
